import { render, staticRenderFns } from "./OaCalendarForm.vue?vue&type=template&id=571a1324"
import script from "./OaCalendarForm.vue?vue&type=script&lang=js"
export * from "./OaCalendarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports